// extracted by mini-css-extract-plugin
export default {"RegistrationPairUp":"PairUp_RegistrationPairUp__TQ1qv","pairRow":"PairUp_pairRow__8b7Fg","pairAnswer":"PairUp_pairAnswer__58Cbu"};